export const POST_CREATE_ORDER = 'POST_CREATE_ORDER';
export const POST_CREATE_ORDER_NO_LOGIN = 'POST_CREATE_ORDER_NO_LOGIN';
export const GET_CONFIG_APP = 'GET_CONFIG_APP';
export const GET_CONFIG_APP_STATUS_DONE = 'GET_CONFIG_APP_STATUS_DONE';

export const POST_UPDATE_INFO_ORDER = 'POST_UPDATE_INFO_ORDER';

export const GET_ALL_SERVICE_ORDER_PRICE = 'GET_ALL_SERVICE_ORDER_PRICE';
export const GET_PRICE_ORDER = 'GET_PRICE_ORDER';

export const GET_INFO_ORDER = 'GET_INFO_ORDER';

export const UPLOAD_FILE_CREATE_ORDER = 'UPLOAD_FILE_CREATE_ORDER';
export const GET_LIST_FILE_BY_ID = 'GET_LIST_FILE_BY_ID';
export const GET_DETAIL_FILE_BY_ID = 'GET_DETAIL_FILE_BY_ID';
export const POST_CREATE_ORDER_FILE = 'POST_CREATE_ORDER_FILE';
export const POST_CREATE_ORDER_FILE_EDIT = 'POST_CREATE_ORDER_FILE_EDIT';
export const GET_INFO_ORDER_DETAIL_FILE = 'GET_INFO_ORDER_DETAIL_FILE';